export const rfi2RawMaterialSectionMapper = {
  //Business Capabilities
  raw_material_capabilities:
    'dynamic_sections.business_capability.raw_material_capabilities',

  raw_material_manufacturing_process:
    'dynamic_sections.business_capability.raw_material_manufacturing_process',
  raw_material_machinery:
    'dynamic_sections.business_capability.raw_material_machinery',
  lab_availability_and_management:
    'dynamic_sections.business_capability.lab_availability_and_management',

  textile_to_textile_recycling_capabilities:
    'dynamic_sections.business_capability.textile_to_textile_recycling_capabilities',

  textile_to_textile_recycling_traceability_quality_practices:
    'dynamic_sections.business_capability.textile_to_textile_recycling_traceability_quality_practices',

  certifications: 'dynamic_sections.business_capability.certifications',

  //Responsible Sourcing
  responsible_sourcing_sustainability_for_raw_material:
    'dynamic_sections.responsible_sourcing.responsible_sourcing_sustainability_for_raw_material',

  //Other Information
  additional_factory_information:
    'dynamic_sections.other_information.additional_factory_information',
  key_factory_personnel:
    'dynamic_sections.other_information.key_factory_personnel',
  factory_automation_level:
    'dynamic_sections.other_information.factory_automation_level',
  employee_information:
    'dynamic_sections.other_information.employee_information',
  footwear_employee_information:
    'dynamic_sections.other_information.footwear_employee_information',
  footwear_factory_ownership:
    'dynamic_sections.other_information.footwear_factory_ownership',
  raw_material_factory_ownership:
    'dynamic_sections.other_information.raw_material_factory_ownership',
  financial_information:
    'dynamic_sections.other_information.financial_information',
}
